import React from 'react'

class NavMeineAzubis extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" data-testid="NavMeineAzubis">
        <path
          fill="#FFF"
          fillRule="nonzero"
          d="M6.888 10.836a5.75 5.75 0 1 1 6.225 0c3.297 1.29 5.637 4.574 5.637 8.414V20H1.25v-.75c0-3.84 2.34-7.123 5.638-8.414zM10 10.25a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5zm0 1.5c-3.755 0-6.85 2.956-7.214 6.75h14.428c-.364-3.794-3.46-6.75-7.214-6.75zM7.54 7.005l.93-.366a1.75 1.75 0 0 0 3.238.053l.918.396a2.75 2.75 0 0 1-5.086-.083z"
        />
      </svg>
    )
  }
}

export default NavMeineAzubis
